// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.onboarding_roleSelectTitle__LXBCr {
	text-align: center;
}

.onboarding_roleButtons__HFIF7 {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}

.onboarding_roleButtons__HFIF7 button {
	text-align: center;
	margin: 0.5rem 0 0.5rem 0;
}

.onboarding_buttonGroup__xjLJc {
	display: flex;
	flex-direction: column;
}

.onboarding_buttonGroup__xjLJc button {
	color: black;
	padding: 10px 16px;
	margin: 8px;
	border: 1px solid #ccc;
	border-radius: 20px;
	background-color: white;
	transition: all 0.2s ease-in-out;
}

.onboarding_buttonGroup__xjLJc button:hover {
	border-color: #999;
}

.onboarding_buttonGroup__xjLJc .onboarding_selected__IcxwU {
	color: white;
	background-color: rgb(105, 145, 163);
}

.onboarding_navigation__C35aW {
	display: flex;
	justify-content: space-between;
	margin-top: 20px;
}

.onboarding_skipButton__hBP-z {
	background-color: transparent;
	padding: 0.25rem;
	margin: 0.5rem;
	width: 0;
	color: rgb(87, 120, 135);
	transition: font-weight 0.2s ease;
}

.onboarding_skipButton__hBP-z:hover {
	font-weight: bold;
}

.onboarding_bottomButtons__D9rOP {
	display: flex;
	justify-content: space-between;
}

.onboarding_button__9X98G:hover {
	background: rgb(87, 120, 135);
}

.onboarding_uploadContainer__R90NE {
	display: flex;
	justify-content: center;
	margin-bottom: 1rem;
}

.onboarding_uploadCircle__HgSS8 {
	width: 140px;
	height: 140px;
	border-radius: 50%;
	border: 2px solid #ddd;
	background-color: white;
	color: #888;
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;
	cursor: pointer;
	position: relative;
	font-size: 0.9rem;
}

.onboarding_profileImage__xaycx {
	width: 100%;
	height: 100%;
	border-radius: 50%;
	object-fit: cover;
}

.onboarding_cameraIcon__HdPMk {
	position: absolute;
	bottom: 8px;
	right: 8px;
	background-color: #85a9b8;
	color: white;
	border-radius: 50%;
	width: 32px;
	height: 32px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 1.1rem;
}

.onboarding_venueContainer__vuEEb {
	display: flex;
	justify-content: center;
}

.onboarding_priceRange__AWrYf {
	display: flex;
	align-items: center;
	justify-content: space-around;
}
`, "",{"version":3,"sources":["webpack://./src/components/onboardingCards/onboarding.module.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,8BAA8B;AAC/B;;AAEA;CACC,kBAAkB;CAClB,yBAAyB;AAC1B;;AAEA;CACC,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,YAAY;CACZ,kBAAkB;CAClB,WAAW;CACX,sBAAsB;CACtB,mBAAmB;CACnB,uBAAuB;CACvB,gCAAgC;AACjC;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,YAAY;CACZ,oCAAoC;AACrC;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,gBAAgB;AACjB;;AAEA;CACC,6BAA6B;CAC7B,gBAAgB;CAChB,cAAc;CACd,QAAQ;CACR,wBAAwB;CACxB,iCAAiC;AAClC;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb,8BAA8B;AAC/B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,YAAY;CACZ,aAAa;CACb,kBAAkB;CAClB,sBAAsB;CACtB,uBAAuB;CACvB,WAAW;CACX,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,kBAAkB;CAClB,eAAe;CACf,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,UAAU;CACV,yBAAyB;CACzB,YAAY;CACZ,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb,uBAAuB;AACxB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,6BAA6B;AAC9B","sourcesContent":[".roleSelectTitle {\r\n\ttext-align: center;\r\n}\r\n\r\n.roleButtons {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tjustify-content: space-between;\r\n}\r\n\r\n.roleButtons button {\r\n\ttext-align: center;\r\n\tmargin: 0.5rem 0 0.5rem 0;\r\n}\r\n\r\n.buttonGroup {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n}\r\n\r\n.buttonGroup button {\r\n\tcolor: black;\r\n\tpadding: 10px 16px;\r\n\tmargin: 8px;\r\n\tborder: 1px solid #ccc;\r\n\tborder-radius: 20px;\r\n\tbackground-color: white;\r\n\ttransition: all 0.2s ease-in-out;\r\n}\r\n\r\n.buttonGroup button:hover {\r\n\tborder-color: #999;\r\n}\r\n\r\n.buttonGroup .selected {\r\n\tcolor: white;\r\n\tbackground-color: rgb(105, 145, 163);\r\n}\r\n\r\n.navigation {\r\n\tdisplay: flex;\r\n\tjustify-content: space-between;\r\n\tmargin-top: 20px;\r\n}\r\n\r\n.skipButton {\r\n\tbackground-color: transparent;\r\n\tpadding: 0.25rem;\r\n\tmargin: 0.5rem;\r\n\twidth: 0;\r\n\tcolor: rgb(87, 120, 135);\r\n\ttransition: font-weight 0.2s ease;\r\n}\r\n\r\n.skipButton:hover {\r\n\tfont-weight: bold;\r\n}\r\n\r\n.bottomButtons {\r\n\tdisplay: flex;\r\n\tjustify-content: space-between;\r\n}\r\n\r\n.button:hover {\r\n\tbackground: rgb(87, 120, 135);\r\n}\r\n\r\n.uploadContainer {\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\tmargin-bottom: 1rem;\r\n}\r\n\r\n.uploadCircle {\r\n\twidth: 140px;\r\n\theight: 140px;\r\n\tborder-radius: 50%;\r\n\tborder: 2px solid #ddd;\r\n\tbackground-color: white;\r\n\tcolor: #888;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\ttext-align: center;\r\n\tcursor: pointer;\r\n\tposition: relative;\r\n\tfont-size: 0.9rem;\r\n}\r\n\r\n.profileImage {\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\tborder-radius: 50%;\r\n\tobject-fit: cover;\r\n}\r\n\r\n.cameraIcon {\r\n\tposition: absolute;\r\n\tbottom: 8px;\r\n\tright: 8px;\r\n\tbackground-color: #85a9b8;\r\n\tcolor: white;\r\n\tborder-radius: 50%;\r\n\twidth: 32px;\r\n\theight: 32px;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\tfont-size: 1.1rem;\r\n}\r\n\r\n.venueContainer {\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n}\r\n\r\n.priceRange {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: space-around;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"roleSelectTitle": `onboarding_roleSelectTitle__LXBCr`,
	"roleButtons": `onboarding_roleButtons__HFIF7`,
	"buttonGroup": `onboarding_buttonGroup__xjLJc`,
	"selected": `onboarding_selected__IcxwU`,
	"navigation": `onboarding_navigation__C35aW`,
	"skipButton": `onboarding_skipButton__hBP-z`,
	"bottomButtons": `onboarding_bottomButtons__D9rOP`,
	"button": `onboarding_button__9X98G`,
	"uploadContainer": `onboarding_uploadContainer__R90NE`,
	"uploadCircle": `onboarding_uploadCircle__HgSS8`,
	"profileImage": `onboarding_profileImage__xaycx`,
	"cameraIcon": `onboarding_cameraIcon__HdPMk`,
	"venueContainer": `onboarding_venueContainer__vuEEb`,
	"priceRange": `onboarding_priceRange__AWrYf`
};
export default ___CSS_LOADER_EXPORT___;
